import events from "_src/engine/events";

const STATE_LOW = 0;
const STATE_MID = 1;
const STATE_HIGH = 2;
let _loadingSpeedState = STATE_MID;
let _FPSSTate = STATE_MID;

const LOADING_TIME_UPPER_THR = 60; //seconds
const LOADING_TIME_LOWER_THR = 5; //seconds
const FPS_UPPER_THR = 55;
const FPS_LOWER_THR = 10;

let _loadsCount = 0;
let _highSpeedReportEnabled = false;

export default {
  setHighSpeedReportEnabled(enabled) {
    _highSpeedReportEnabled = enabled;
  },

  registerLoadingObject() {
    _loadsCount++;
  },

  unregisterLoadingObject() {
    _loadsCount--;
  },

  reportFrameTime: (function() {
    let currentTime = 0;
    let currentFramesCount = 0;
    const fpsMeasurements = [];
    const AVERAGE_PERIOD = 10;
    return function (time) {
      currentFramesCount++;
      currentTime += time;
      if (currentTime > 1) {
        const fpsMeasurement = currentFramesCount;
        fpsMeasurements.push(fpsMeasurement);
        currentTime = 0;
        currentFramesCount = 0;
      }

      if (fpsMeasurements.length > AVERAGE_PERIOD) {
        const sum = fpsMeasurements.reduce((a, b) => a + b, 0);
        const avg = (sum / fpsMeasurements.length) || 0;

        if (avg > FPS_UPPER_THR) {
          _FPSSTate = STATE_HIGH;
        } else if (avg < FPS_LOWER_THR) {
          _FPSSTate = STATE_LOW;
        } else {
          _FPSSTate = STATE_MID;
        }

        fpsMeasurements.shift();
      }

    }
  })(),

  update(time) {
    _updateLoadingSpeedState(time);
    _generateReport();
  }
}

const _updateLoadingSpeedState = (() => {
  let isHighSpeedTracked = false;
  let loadStart = null;
  return function (time) {
    if (_loadsCount > 0) {
      if (loadStart === null) {
        loadStart = time;
        isHighSpeedTracked = _highSpeedReportEnabled;
      } else {
        if (time - loadStart > LOADING_TIME_UPPER_THR) {
          _loadingSpeedState = STATE_LOW;
        } else {
          _loadingSpeedState = STATE_MID;
        }
      }
    } else {
      if (loadStart !== null) {
        if (isHighSpeedTracked && (time - loadStart < LOADING_TIME_LOWER_THR)) {
          _loadingSpeedState = STATE_HIGH;
          return;
        }
        loadStart = null;
      }
    }
  }
})();

const _generateReport = (() => {
  let lastReportedState = STATE_MID;
  return function () {
    const slowLoadingCondition = _loadingSpeedState === STATE_LOW;
    const fastLoadingCondition = _loadingSpeedState === STATE_HIGH && _loadsCount === 0;
    const lowFPSCondition = _FPSSTate === STATE_LOW;
    const highFPSCondition = _FPSSTate === STATE_HIGH && _loadsCount === 0;

    if (slowLoadingCondition || lowFPSCondition) {
      if (lastReportedState !== STATE_LOW) {
        events.emit("lowPerformance");
        lastReportedState = STATE_LOW;
      }
    } else if (fastLoadingCondition && highFPSCondition) {
      if (lastReportedState !== STATE_HIGH) {
        events.emit("highPerformance");
        lastReportedState = STATE_HIGH;
      }
    } else {
      lastReportedState = STATE_MID;
    }
  }
})();
